import React from "react";
import styled from "styled-components";
import Container from "../Common/Container";

const Wrapper = styled.section`
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem 1.5rem 4rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 1.2rem;
  box-shadow: 0 2px 16px rgba(233, 125, 125, 0.07);
`;

const Title = styled.h1`
  font-family: "Playfair Display", serif;
  font-size: 2.5rem;
  color: #e97d7dff;
  margin-bottom: 1.2rem;
  text-align: center;
`;

const Subtitle = styled.h2`
  font-size: 1.3rem;
  color: #222;
  font-weight: 500;
  margin-bottom: 2rem;
  text-align: center;
`;

const Text = styled.p`
  font-size: 1.13rem;
  color: #444;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Highlight = styled.span`
  color: #e97d7dff;
  font-weight: 600;
`;

const AboutUs: React.FC = () => (
  <section style={{ padding: "3rem 0" }}>
    <Container>
      <Wrapper>
        <Title>About Craft Bin</Title>
        <Subtitle>Handcrafted with Heart. Inspired by You.</Subtitle>
        <Text>
          Welcome to <Highlight>Craft Bin</Highlight>—your destination for
          unique, handcrafted resin jewelry, home decor, and gifts. Our mission
          is to bring a touch of artistry and joy to your everyday life, one
          piece at a time.
        </Text>
        <Text>
          Every item in our shop is lovingly made by hand, blending creativity,
          quality, and a passion for detail. We believe in celebrating
          individuality, supporting small makers, and making it easy for you to
          find the perfect piece for yourself or someone special.
        </Text>
        <Text>
          Thank you for supporting our small business and for being part of our
          creative journey!
        </Text>
      </Wrapper>
    </Container>
  </section>
);

export default AboutUs;
